import React, { useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom';
import { Model } from "survey-core";
import { Survey, ReactSurveyElement, ReactElementFactory } from "survey-react-ui";
import Alert from 'react-bootstrap/Alert';
import { PlainLight } from "survey-core/themes";
import "survey-core/survey-core.css";
//import "survey-core/defaultV2.css";
import { DateTime } from 'luxon';
import resolveSurvey from "../data/surveyResolver.js";
import CustomRatingItem from  "../components/survey/CustomRatingItem.js"


const storageItemKey = "alignOrg-survey";

class PercentageProgressBar extends ReactSurveyElement {
  render() {
      return (
          <div className="sv-progressbar-percentage">
            <div className="sv-progressbar-percentage__title">
              <span>{this.props.model.progressTitle}</span>
            </div>
            <div className="sv-progressbar-percentage__indicator">
              <div className="sv-progressbar-percentage__value-bar" style={{ width: this.props.model.progressValue + "%" }}></div>
            </div>
            <div className="sv-progressbar-percentage__value">
              <span>{this.props.model.progressValue + "%"}</span>
            </div>
          </div>
      );
  }
}

ReactElementFactory.Instance.registerElement("sv-progressbar-percentage", props => {
  return React.createElement(PercentageProgressBar, props);
});

ReactElementFactory.Instance.registerElement("custom-rating-item", CustomRatingItem);

// Survey.ComponentCollection.Instance.add({
//   name: 'custom-rating-item', // The type name used in your JSON
//   title: 'My Custom Question',
//   questionJSON: {
//       // Default properties for your custom question
//       type: 'mycustomquestion',
//       name: 'defaultName',
//   },
//   // Render the custom React component
//   onRender: (survey, el) => {
//       const question = survey.getQuestionByValueName(el.id); // Get the question instance
//       if (question) {
//           ReactDOM.render(
//               <MyCustomQuestionComponent question={question} />,
//               el
//           );
//       }
//   },
//   // Clean up when the component is unmounted
//   onUnmount: (survey, el) => {
//       ReactDOM.unmountComponentAtNode(el);
//   },
// });

//?clientId=664eb6124d2de2bcd6c52268&surveyId=664eb5ea4d2de2bcd6c52267&employeeId=664eb63e4d2de2bcd6c52269
export function SurveyPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const surveyId = searchParams.get("surveyId");
  const clientId = searchParams.get("clientId");
  const employeeId = searchParams.get("employeeId");
  const initialSurveyResult = { surveyId, clientId, employeeId, isComplete: false, pageNumber: 0, questionResults: [] };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [clientSurvey, setClientSurvey] = useState(null);
  const [surveyResult, setSurveyResult] = useState(initialSurveyResult);
  const [survey, setSurvey] = useState(new Model(resolveSurvey(null)));

    survey.applyTheme(PlainLight);
    setSurveyDataFromSurveyResult(surveyResult);
    survey.logoWidth = "40%";
    survey.logoFit = "contain";
  // survey.addLayoutElement({
  //   id: "progressbar-percentage",
  //   component: "sv-progressbar-percentage",
  //   container: "contentTop",
  //   data: survey
  // });

  // survey.onAfterRenderItem.add((sender, options) => {
  //   if (options.question.getType() === "rating") {
  //     // You would typically use a more integrated method using React rendering mechanisms,
  //     // but this demonstrates the logic.
  //     // In a real React app, you'd use survey.onAfterRenderQuestion to handle rendering
  //     // of custom React components for the entire question or individual items.
  //     // For the built-in rating, descriptions are handled via CSS/internal logic.
  //   }
  // })

  const getSurvey = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}Clients/${clientId}/Surveys/${surveyId}`;
      const response = await fetch(url);

      if (response.ok) {
        const surveyData = await response.json();
        //Check if survey is closed
        var now = DateTime.now().setZone('utc');
        var endDate = DateTime.fromISO(surveyData.endDate, {zone: "UTC"}); //do not convert from UTC as we only want date
        if(surveyData.status === "Closed" || now.startOf('day') > endDate.startOf('day')) {
          setError("This survey is closed");  //survey.SurveyError("This survey is closed");  
        }
        else {
          setClientSurvey(surveyData);
          setSurvey(new Model(resolveSurvey(surveyData.surveyType, { team: surveyData.team })));
        }
      }
      else
        setError("Survey not found");

    } catch (error) {
      setError(error.message);
    }
  }

  const getSurveyResult = async () => {    
    try {
      // Check local storage for survey data
      let surveyResultData = window.localStorage.getItem(storageItemKey) || null;
      if (surveyResultData) {
        surveyResultData = JSON.parse(surveyResultData);
        //SurveyResult from local storage is for a different employee
        if (surveyResultData.clientId !== clientId || surveyResultData.employeeId !== employeeId || surveyResultData.surveyId !== surveyId) {
          window.localStorage.setItem(storageItemKey, "");
          surveyResultData = null;
        }
      }

      // No data from local storage so check db for survey data
      if (!surveyResultData) {
        const url = `${process.env.REACT_APP_API_URL}SurveyResults/query?surveyId=${surveyId}&clientId=${clientId}&employeeId=${employeeId}`;
        const response = await fetch(url);

        if (response.ok) {
          surveyResultData = await response.json();
          window.localStorage.setItem(storageItemKey, JSON.stringify(surveyResultData));
        }
      }

      //First time the user has opened the survey
      if (!surveyResultData) { 
        window.localStorage.setItem(storageItemKey, JSON.stringify(surveyResult));
        const status = `Page ${survey.currentPageNo + 1}: ${survey.currentPage.name}`;
        updateEmployeeStatus(status);
      }

      // User has answered at least one question
      if (surveyResultData && surveyResultData.questionResults.length > 0) {
        setSurveyResult(surveyResultData);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const surveyId = searchParams.get("surveyId");
    const clientId = searchParams.get("clientId");
    const employeeId = searchParams.get("employeeId");
    if(surveyId && clientId && employeeId) {
      if(!clientSurvey)
        getSurvey();
      if (surveyResult.questionResults.length === 0) {
        getSurveyResult();
      }
    }
    else {
      setError("Invalid Survey");  //survey.SurveyError("Invalid Survey");  
      setLoading(false);
    }
  }, [searchParams]);

  function onValueChanged(survey, options) {
    surveyResult.pageNumber = survey.currentPageNo;
    const currentPage = survey.currentPage;
    const question = options.question;
    const questionId = parseInt(options.name.substring(1));
    const questionType = question.getType();
    let questionResult = surveyResult.questionResults.find(a => a.questionId === questionId);

    if (!questionResult) {
      questionResult = {
        questionId: questionId,
        questionGroup: currentPage.name,
        questionType: questionType,
        questionName: options.name,
        score: questionType === "rating" ? options.value : undefined,
        comment: questionType === "comment" ? options.value : undefined,
      };
      surveyResult.questionResults.push(questionResult);
    }
    else {
      questionResult.questionId = questionId;
      questionResult.questionGroup = currentPage.name;
      questionResult.questionType = questionType;
      questionResult.questionName = options.name;
      questionResult.score = questionType === "rating" ? options.value : undefined;
      questionResult.comment = questionType === "comment" ? options.value : undefined;
    }

    window.localStorage.setItem(storageItemKey, JSON.stringify(surveyResult));
    //saveSurveyResults();
  }

  function onCurrentPageChanged(survey, options) {
    surveyResult.pageNumber = survey.currentPageNo;
    window.localStorage.setItem(storageItemKey, JSON.stringify(surveyResult));
    saveSurveyResults();
    const status = `Page ${survey.currentPageNo + 1}: ${options.newCurrentPage.name}`;
    updateEmployeeStatus(status);
  }

  function onComplete(survey) {
    window.localStorage.setItem(storageItemKey, "");
    surveyResult.isComplete = true;
    saveSurveyResults();
    updateEmployeeStatus("Completed");
  }

  const saveSurveyResults = async () => {
    try {
      const url = surveyResult.id ? `${process.env.REACT_APP_API_URL}SurveyResults/${surveyResult.id}` : `${process.env.REACT_APP_API_URL}SurveyResults`;
      const method = surveyResult.id ? "PUT" : "POST";
      var params = {
        method,
        body: JSON.stringify(surveyResult),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        }
      };
      const response = await fetch(url, params);
      if (!response.ok) {
        throw new Error('Could not save survey data.');
      }
      if (response.status === 201) { //created
        const data = await response.json();
        setSurveyResult(data);
        window.localStorage.setItem(storageItemKey, JSON.stringify(surveyResult));
      }
      //setLoading(false);
    } catch (error) {
      setError(error.message);
      //setLoading(false);
    }
  }

  function setSurveyDataFromSurveyResult(surveyResult) {
    let answerData = {}
    surveyResult.questionResults.forEach(a => answerData[a.questionName] = a.score ? a.score : a.comment);
    survey.data = answerData;
    if (surveyResult.pageNumber) {
      survey.currentPageNo = surveyResult.pageNumber;
    }
  }

  const updateEmployeeStatus = async (status) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}Clients/${clientId}/Employees/${employeeId}/SurveyStatus/${status}`;
      const method = "PUT";
      var params = {
        method,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        }
      };
      const response = await fetch(url, params);
      if (!response.ok) {
        throw new Error('Could not update employee status.');
      }
    } catch (error) {
      setError(error.message);
    }
  }

  return (
    <div className="container">
      {
        loading ? (
          <div className="h-100 d-flex justify-content-center align-items-center">
            <span className="spinner-border text-primary" style={{width: "4rem", height: "4rem"}} role="status" />
          </div>
        ) : error ? (
          <Alert key="danger" variant="danger">Error: {error}</Alert>
        ) : (
          <Survey
            model={survey}
            onComplete={onComplete}
            onValueChanged={onValueChanged}
            onCurrentPageChanged={onCurrentPageChanged}
          />
        )
      }
    </div>
  );
}
